import { useRef } from 'react';

export const useFocus = (): any => {
    const htmlElRef = useRef(null) as any;

    const setFocus = () => {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        htmlElRef.current && htmlElRef.current.focus();
    };

    return [htmlElRef, setFocus];
};
